import { render, staticRenderFns } from "./DetalleOrden.vue?vue&type=template&id=59a39444&scoped=true&"
import script from "./DetalleOrden.vue?vue&type=script&lang=js&"
export * from "./DetalleOrden.vue?vue&type=script&lang=js&"
import style0 from "./DetalleOrden.vue?vue&type=style&index=0&id=59a39444&lang=scss&scoped=true&"
import style1 from "./DetalleOrden.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a39444",
  null
  
)

export default component.exports